/**
 * Admin access utility functions
 */

/**
 * Check if user has admin access
 * @param {Object} user - User object from AuthContext
 * @returns {boolean} - True if user is admin
 */
export const isAdmin = (user) => {
  return user && user.role === 'ADMIN';
};

/**
 * Check if user has manager or admin access
 * @param {Object} user - User object from AuthContext
 * @returns {boolean} - True if user is manager or admin
 */
export const isManagerOrAdmin = (user) => {
  return user && (user.role === 'ADMIN' || user.role === 'MANAGER');
};

/**
 * Show admin access required notification
 * @param {string} action - The action that requires admin access
 */
export const showAdminAccessRequired = (action = 'perform this action') => {
  window.dispatchEvent(new CustomEvent('app:notify', {
    detail: {
      type: 'warning',
      message: `Admin access required to ${action}. Please contact your administrator.`
    }
  }));
};

/**
 * Show admin access dialog
 * @param {string} action - The action that requires admin access
 * @param {Function} onContactAdmin - Callback when user clicks contact admin
 */
export const showAdminAccessDialog = (action = 'perform this action', onContactAdmin = null) => {
  window.dispatchEvent(new CustomEvent('app:show-admin-dialog', {
    detail: {
      action,
      onContactAdmin
    }
  }));
};

/**
 * Admin access requirements for different actions
 */
export const ADMIN_ACTIONS = {
  CREATE_CATEGORY: 'create categories',
  UPDATE_CATEGORY: 'update categories',
  DELETE_CATEGORY: 'delete categories',
  CREATE_TEMPLATE: 'create templates',
  UPDATE_TEMPLATE: 'update templates',
  DELETE_TEMPLATE: 'delete templates',
  MANAGE_USERS: 'manage users',
  MANAGE_TENANTS: 'manage tenants',
  APPROVE_TEMPLATES: 'approve templates',
  SYSTEM_SETTINGS: 'access system settings'
};
